module.exports = __webpack_public_path__ + "static/media/cluster-lg.471c46a9.svg";